import { render, staticRenderFns } from "./NumberInputConfig.vue?vue&type=template&id=f22787b8&scoped=true"
import script from "./NumberInputConfig.vue?vue&type=script&lang=js"
export * from "./NumberInputConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22787b8",
  null
  
)

export default component.exports